import React, { useEffect, useState } from 'react';
import { Box, Flex, HStack, IconButton, Heading, Text, Image, Button, Stack, useDisclosure, Link } from '@chakra-ui/react';
import logoImage from '../assets/images/logo512.png'
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons'
import RSVPStatusChart from './authAdmin/statistics/rsvpGuests';
import { getAdminAllGuestInvites, getAdminAllGuests } from '../service/api/event';


const HomePage = () => {

    const [confirmedGuests, setConfirmedGuests] = useState(0)
    const [pendingGuests, setPendingGuests] = useState(0)
    const [declinedGuests, setDeclinedGuests] = useState(0)

    const intitalizeData = async () => {
        const appResp = await getAdminAllGuests();
        const guestsInvitedResp = await getAdminAllGuestInvites();

        if (appResp != null) {
            let confirmedMain = 0;
            let confirmedAddtl = 0;
            let declinedMain = 0;
            let declinedAddtl = 0;
            let pendingMain = 0;
            let pendingAddtl = 0;

            guestsInvitedResp.forEach((guest) => {
                const allocatedAddtl = guest.allocated_guests.length || 0;
                if (!guest.has_response) {
                    pendingMain += 1;
                    pendingAddtl += allocatedAddtl;
                }

            });
            appResp.forEach((guest) => {
                const allocatedAddtl = guest.allocated_guests.length || 0;
                const confirmedAddtlCount = guest.confirmed_guests.length || 0;

                if (guest.response === "Yes") {
                    // ✅ Confirmed: main + confirmed additional
                    confirmedMain += 1;
                    confirmedAddtl += confirmedAddtlCount;

                    // ✅ Declined: unused allocated
                    if (allocatedAddtl > confirmedAddtlCount) {
                        declinedAddtl += allocatedAddtl - confirmedAddtlCount;
                    }

                } else if (guest.response === "No") {
                    // ✅ Declined: main + all allocated
                    declinedMain += 1;
                    declinedAddtl += allocatedAddtl;

                } else {
                    // ✅ Pending: main + all allocated
                    pendingMain += 1;
                    pendingAddtl += allocatedAddtl;
                }
            });

            const totalConfirmed = confirmedMain + confirmedAddtl;
            const totalDeclined = declinedMain + declinedAddtl;
            const totalPending = pendingMain + pendingAddtl;

            setConfirmedGuests(totalConfirmed);
            setDeclinedGuests(totalDeclined);
            setPendingGuests(totalPending);
        }
    };



    useEffect(() => {
        intitalizeData();
    }, [])


    const { isOpen, onOpen, onClose } = useDisclosure();
    return (
        <div>
            <RSVPStatusChart
                confirmedGuests={confirmedGuests}
                pendingGuests={pendingGuests}
                declineCount={declinedGuests} />
        </div>
    );
};


export default HomePage;
